// Product Page Translations
export const productPageTranslations = {
  en: {
    // Header
    pageTitle: 'All Products',
    pageSubtitle: 'Discover our curated collection',

    // Sorting & Filtering
    sortBy: 'Sort by',
    filters: 'Filters',
    category: 'Category',
    searchPlaceholder: 'Search product by name or brand',

    // Sort Options
    sortNewest: 'Newest',
    sortPopular: 'Most Popular',
    sortLowToHigh: 'Price: Low to High',
    sortHighToLow: 'Price: High to Low',
    sortRating: 'Highest Rated',

    // Product Info
    rating: 'Rating',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',
    viewDetails: 'View Details',
    billedMonthly: 'Billed monthly',
    billedYearly: 'Billed yearly',
    regularPrice: 'Regular: ',
    save: 'Save',

    // Pagination
    showing: 'Showing',
    to: 'to',
    of: 'of',
    results: 'results',
    previous: 'Previous',
    next: 'Next',

    // No Results
    noProducts: 'No products found',
    tryDifferentSearch: 'Try a different search or adjust your filters',

    // Category Labels
    streaming: 'Streaming',
    productivity: 'Productivity',
    security: 'Security',
    education: 'Education',
    design: 'Design',
    development: 'Development',
    other: 'Other',
  },

  fr: {
    // Header
    pageTitle: 'Tous les Produits',
    pageSubtitle: 'Découvrez notre collection soigneusement sélectionnée',

    // Sorting & Filtering
    sortBy: 'Trier par',
    filters: 'Filtres',
    category: 'Catégorie',
    searchPlaceholder: 'Rechercher un produit par nom ou marque',

    // Sort Options
    sortNewest: 'Plus Récent',
    sortPopular: 'Plus Populaire',
    sortLowToHigh: 'Prix: Bas à Haut',
    sortHighToLow: 'Prix: Haut à Bas',
    sortRating: 'Mieux Noté',

    // Product Info
    rating: 'Note',
    outOfStock: 'Rupture de Stock',
    inStock: 'En Stock',
    viewDetails: 'Voir Détails',
    billedMonthly: 'Facturé mensuellement',
    billedYearly: 'Facturé annuellement',
    regularPrice: 'Régulier: ',
    save: 'Économisez',

    // Pagination
    showing: 'Affichage',
    to: 'à',
    of: 'de',
    results: 'résultats',
    previous: 'Précédent',
    next: 'Suivant',

    // No Results
    noProducts: 'Aucun produit trouvé',
    tryDifferentSearch: 'Essayez une recherche différente ou ajustez vos filtres',

    // Category Labels
    streaming: 'Streaming',
    productivity: 'Productivité',
    security: 'Sécurité',
    education: 'Éducation',
    design: 'Design',
    development: 'Développement',
    other: 'Autre',
  },
};

export const useProductPageTranslations = (language = 'en') => {
  return productPageTranslations[language] || productPageTranslations['en'];
};
